<template>
    <div class="create-request">
        <h3>Запрос на удаление</h3>
        <div class="input-container">
            <span>Email</span>
            <el-input v-model="form.email"></el-input>
        </div>
        <div class="input-container">
            <span>Текст запроса</span>
            <el-input type="textarea" v-model="form.text"></el-input>
        </div>
        <el-button class="create-request__send-btn" type="primary">Отправить</el-button>
    </div>
</template>

<script>
export default {
    data() {
        return {
            form:{
                email:'',
                text:''
            }
        }
    },
}
</script>

<style  lang="scss">
    .create-request{
        .input-container{
            margin-bottom: 20px;
            span{
                color: $regular-text-clr;
                display: block;
                margin-bottom: 10px;
            }
        }
        .create-request__send-btn{
            text-align: center;
        }
    }
</style>